import { render, staticRenderFns } from "./ModalSolicitacaoComentario.vue?vue&type=template&id=5edc8c20&scoped=true"
import script from "./ModalSolicitacaoComentario.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoComentario.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoComentario.vue?vue&type=style&index=0&id=5edc8c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edc8c20",
  null
  
)

export default component.exports